import { useQuery } from "@tanstack/react-query";
import { Spin } from "antd";
import { journalsQueries } from "@/entities/journal";
import { useCoordinator } from "@/shared/lib/hooks";
import { JournalsStateSupervision } from "../journals-state-supervision";
import { JournalsSupervisionOfficial } from "../journals-supervision-official";
import { JournalsSupervisionRegistration } from "../journals-supervision-registration";

export const JournalsRegistrationDetails = () => {
  const { titleId } = useCoordinator();
  const { data: titleData, isPending: isTitleLoading } = useQuery(
    journalsQueries.getTitleJournal({ titleId }),
  );

  if (isTitleLoading) {
    return (
      <Spin>
        <div className="journals-main-column-wrapper" />
      </Spin>
    );
  }

  return (
    <div className="journals-main-column-wrapper">
      <JournalsStateSupervision titleData={titleData} />
      <JournalsSupervisionOfficial titleData={titleData} />
      <JournalsSupervisionRegistration titleData={titleData} />
    </div>
  );
};
